/**
 * Which masthead controls a surface shows. Pure so the "trim the chrome" rule is provable without rendering the route.
 *
 * The run timer and the Analysis menu read stores only the OLD run lane writes (`RunTimer` reads `runStateStore`, the Analysis panels
 * read `multiAgentIdeStore` analysis that no Lane V2 path fills). On Lane V2 they render an empty pill and an empty menu: chrome that
 * promises something and shows nothing. They stay on the old lane, where they work.
 */
export interface MastheadControls {
  /** The elapsed-time pill. */
  timer: boolean;
  /** The Analysis (impact / dependencies / tests) menu. */
  analysis: boolean;
}

export function mastheadControls(laneV2Active: boolean): MastheadControls {
  return { timer: !laneV2Active, analysis: !laneV2Active };
}

/** Whether the status pill (timer + MCP tool count) has anything to hold. */
export function showStatusPill(controls: MastheadControls, toolCount: number): boolean {
  return controls.timer || toolCount > 0;
}
